import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=5f80d6b3&lang=pug"
import script from "./ThemeSelector.vue?vue&type=script&lang=ts"
export * from "./ThemeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports